const breadcrumbsEl = document.querySelector('.breadcrumbs');
const mediaBreakPoint = '(max-width: 480px)';
const mq = window.matchMedia(mediaBreakPoint);

const handlebreadcrumbClick = (e) => {
    e.preventDefault();
    const target = e.currentTarget;

    const previousSiblingEl = target.previousElementSibling;
    if (previousSiblingEl.hasAttribute('data-link')) {
        window.location.href = previousSiblingEl.getAttribute('data-link');
    }
};

if (breadcrumbsEl) {
    const breadcrumbEls = breadcrumbsEl.querySelectorAll('.breadcrumb-item');

    const breadcrumbGoBack = function(mq) {
        if (mq.matches) {
            breadcrumbsEl.classList.add('mobile-view');

            for (const breadcrumbEl of breadcrumbEls) {
                if (breadcrumbEl.previousElementSibling) {
                    breadcrumbEl.innerText = 'Back to ' + breadcrumbEl.previousElementSibling.getAttribute('data-page-name');
                    breadcrumbEl.addEventListener('click', handlebreadcrumbClick);
                }
            }
        } else if (!mq.matches && breadcrumbsEl.classList.contains('mobile-view')) {
            breadcrumbsEl.classList.remove('mobile-view');

            for (const breadcrumbEl of breadcrumbEls) {
                breadcrumbEl.innerText = breadcrumbEl.getAttribute('data-page-name');

                if (breadcrumbEl.hasAttribute('data-link')) {
                    const breadcrumbLinkEl = document.createElement('a');
                    breadcrumbLinkEl.href = breadcrumbEl.getAttribute('data-link');
                    breadcrumbLinkEl.title = breadcrumbEl.innerText;
                    breadcrumbLinkEl.innerText = breadcrumbEl.innerText;

                    breadcrumbEl.innerHTML = '';
                    breadcrumbEl.appendChild(breadcrumbLinkEl);
                }
                breadcrumbEl.removeEventListener('click', handlebreadcrumbClick);
            }
        }
    };

    mq.addListener(breadcrumbGoBack);
    breadcrumbGoBack(mq);
}